import kidneysPNG from '~/assets/images/anatomy/kidneys.png'
import kidneysWEBP from '~/assets/images/anatomy/kidneys.webp'
import liverPNG from '~/assets/images/anatomy/liver.png'
import liverWEBP from '~/assets/images/anatomy/liver.webp'
import skinPNG from '~/assets/images/anatomy/skin.png'
import skinWEBP from '~/assets/images/anatomy/skin.webp'
import stomachPNG from '~/assets/images/anatomy/stomach.png'
import stomachWEBP from '~/assets/images/anatomy/stomach.webp'
import GridChoice from '~/pages/anatomy/libs/components/GridChoice'
import { TPageProps } from '~/shared/types/commonTypes'

const OPTIONS = [
  {
    key: 'liver',
    i18nKey: 'onboarding.organRegenerates.options.liver',
    png: liverPNG,
    webp: liverWEBP,
  },
  {
    key: 'skin',
    i18nKey: 'onboarding.organRegenerates.options.skin',
    png: skinPNG,
    webp: skinWEBP,
  },
  {
    key: 'kidneys',
    i18nKey: 'onboarding.organRegenerates.options.kidneys',
    png: kidneysPNG,
    webp: kidneysWEBP,
  },
  {
    key: 'stomach',
    i18nKey: 'onboarding.organRegenerates.options.stomach',
    png: stomachPNG,
    webp: stomachWEBP,
  },
]

const OrganRegenerates = (props: TPageProps) => (
  <GridChoice
    {...props}
    options={OPTIONS}
    questionKey="onboarding.organRegenerates.question"
    question="Which organ is capable of fully regenerating itself, even if 70% of it is removed?"
    answersAtBottom
  />
)

export default OrganRegenerates
